import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AddOfficeForm from '@/components/forms/add-office/add-office-form';
import { AddOfficeFormValues } from '@/components/forms/add-office/schema';
import { useAddOfficeForm } from '@/components/forms/add-office/use-add-office-form';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import useAddOfficeMutation from '@/hooks/mutations/use-add-office';
import { selectSheetViewModel } from './sheet.viewmodel';

export const AddOfficeSheet = ({
  onClose,
}: {
  onClose: ({ success }: { success: boolean }) => void;
}) => {
  const { t } = useTranslation();
  const sheetViewModel = selectSheetViewModel({
    sheetName: 'AddOfficeSheet',
    api: {
      onClose,
    },
  });

  const { addOfficeForm } = useAddOfficeForm();
  const { mutate: addOffice, isPending, isSuccess } = useAddOfficeMutation();

  useEffect(() => {
    if (isSuccess) {
      sheetViewModel.api.close({ success: true });
    }
  }, [isSuccess]);

  const submitAddOffice = (values: AddOfficeFormValues) => {
    addOffice(values);
  };
  const submit = () => {
    addOfficeForm.trigger();
    addOfficeForm.handleSubmit(submitAddOffice)();
  };

  return (
    <Sheet
      open={sheetViewModel.data.show}
      onOpenChange={sheetViewModel.api.onOpenChange}
    >
      <SheetContent
        side="right"
        className="flex flex-col"
      >
        <SheetHeader>
          <SheetTitle>{t('add-office-sheet.title')}</SheetTitle>
          <SheetDescription></SheetDescription>
        </SheetHeader>

        <div className="min-h-0 flex-1 overflow-y-auto p-4">
          <AddOfficeForm form={addOfficeForm} />
        </div>
        <SheetFooter>
          <Button
            type="submit"
            onClick={submit}
            loading={isPending}
          >
            {t('btn.save')}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};
